import { type FragmentType, useFragment } from "@repo/graphql-types";
import { graphql } from "@repo/graphql-types/gql";
import { CommunityCardItemList } from "@/components/community-card-item-list";
import { CommunityEmptyState } from "@/components/community-empty-state";
import { ListRoot } from "@/components/list";

const CommunityListMapFragment = graphql(/* GraphQL */ `
  fragment CommunityListMapFragment on PerfisComunidadeConnection {
    listaMembros: nodes {
        codUsuario
        nome
        site
        telefone
        ramal
        urlFoto
        follow {
          codUsuarioFollowing
          codUsuarioFollower
        }
        unidades {
          nome
        }
        especialidades {
          nome
        }
      }
  }`);

interface CommunityListMapProps {
  listData: FragmentType<typeof CommunityListMapFragment>;
  tabSelectedLabel: string;
}

export const CommunityListMap = ({
  listData,
  tabSelectedLabel,
}: CommunityListMapProps): JSX.Element => {
  const fragmentData = useFragment(CommunityListMapFragment, listData);
  const checkForDuplicate = (
    value: string | null | undefined,
    index: number,
    array: (string | null | undefined)[],
  ): boolean => array.indexOf(value ?? "") === index;

  return (
    <ListRoot className="flex flex-col gap-2 divide-y-1 divide-gray-200">
      {(fragmentData.listaMembros?.length ?? 0) > 0 ? (
        fragmentData.listaMembros?.map((member) => (
          <CommunityCardItemList
            codUsuario={member?.codUsuario ?? 0}
            key={`list-item-${member?.codUsuario}`}
            memberName={member?.nome ?? ""}
            specialty={member?.especialidades?.map((x) => x.nome).join(", ") ?? ""}
            locations={
              member?.unidades?.map((x) => x.nome).filter(checkForDuplicate) as string[]
            }
            website={member?.site ?? ""}
            phone={member?.ramal ?? ""}
            oneliv=""
            whatsapp={member?.telefone ?? ""}
            photoUrl={member?.urlFoto ?? ""}
            isFavorite={(member?.follow.length ?? 0) > 0}
          />
        ))
      ) : (
        <CommunityEmptyState tabSelectedLabel={tabSelectedLabel} />
      )}
    </ListRoot>
  );
};
